import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Axios from 'axios';
import '@/assets/css/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import i18n from '@/utils/i18n';

export const HTTP = Axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

Vue.prototype.$http = HTTP;

export const axiosConfig = HTTP.interceptors.request.use(config =>
  store.dispatch('startRequest').then(() => {
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: 'JWT ' + store.getters.auth.token
    };
    return config;
  }), (error) => store.dispatch('endRequest').then(() => {
    return Promise.reject(error);
  })
);

HTTP.interceptors.response.use(response => store.dispatch('endRequest').then(() => {
  return response;
}),(error) => store.dispatch('endRequest').then(() => {
  return Promise.reject(error);
})
);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
